import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["filterFormSubmitButton", "selectedEvaluationDefinitions"];

  static classes = ["dragHandle"];

  static values = {
    submitTypeKey: String,
    addEvaluationDefinitionSubmitType: String,
  };

  /**
   * Makes the selected evaluation definitions <ul /> sortable using sortablejs.
   * <li />s that can be sorted need to have a
   * `data-position-field-id_for_label` attribute set.
   */
  selectedEvaluationDefinitionsTargetConnected(target) {
    this.sortableSelectedEvaluationDefinitions = new Sortable(target, {
      animation: 150,
      // Only allows dragging <li />s that have a `data-position-field-id`
      // attribute set to none-empty values.
      draggable: 'li[data-position-field-id]:not([data-position-field-id=""])',
      handle: `.${this.dragHandleClass}`,
      // Only allows targeting other <li />s that have a
      // `data-position-field-id` attribute set.
      onMove: ({ related }) => !!related.dataset.positionFieldId,
      onEnd: () => {
        const lis = target.querySelectorAll(
          ":scope > li[data-position-field-id]",
        );
        lis.forEach((li, index) => {
          const {
            dataset: { positionFieldId },
          } = li;
          const input = li.querySelector(`input[id="${positionFieldId}"]`);
          input.value = index;
        });
      },
    });
  }

  /**
   * Scrolls to the `selectedEvaluationDefinitions` target.
   */
  scrollToSelectedEvaluationDefinitions() {
    if (this.hasSelectedEvaluationDefinitionsTarget) {
      this.selectedEvaluationDefinitionsTarget.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }

  /**
   * Submits the filter form.
   */
  submitFilterForm() {
    if (this.hasFilterFormSubmitButtonTarget) {
      this.filterFormSubmitButtonTarget.click();
    }
  }

  /**
   * Scrolls to the `selectedEvaluationDefinitions` target when an evaluation
   * definitions is successfully added.
   */
  submitEnd(event) {
    const { detail: { formSubmission = {}, success } = {} } = event;
    const { submitter = {} } = formSubmission;
    const { name: submitterName, value: submitterValue } = submitter;

    const isAddEvaluationDefinitionSubmitType =
      submitterName === this.submitTypeKeyValue &&
      submitterValue.startsWith(this.addEvaluationDefinitionSubmitTypeValue);

    if (isAddEvaluationDefinitionSubmitType && success) {
      this.scrollToSelectedEvaluationDefinitions();
    }
  }
}
